"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipHost = void 0;
var Utilities_1 = require("../../Utilities");
var TooltipHost_base_1 = require("./TooltipHost.base");
var TooltipHost_styles_1 = require("./TooltipHost.styles");
exports.TooltipHost = (0, Utilities_1.styled)(TooltipHost_base_1.TooltipHostBase, TooltipHost_styles_1.getStyles, undefined, {
    scope: 'TooltipHost',
});
//# sourceMappingURL=TooltipHost.js.map